export const ChatInputZIndex = 10;

/** Chat prose, tuned to Slack's message density (15px on ~22px lines):
 *  bigger than the app's 14px chrome, tighter leading than an essay column.
 *  Shared by both bubbles so they read as one conversation. */
export const ChatProseFontSize = '15px';
export const ChatProseLineHeight = 1.47;
/** Regular body face in the theme's secondary text gray. */
export const ChatProseFontFamily = 'Wotfard-Regular';
/** Emphasis, headings, and table headers share one treatment — the body face
 *  at weight 600, near-black — so bold reads the same in prose and tables. */
export const ChatEmphasisFontWeight = 600;
export const ChatEmphasisColor = '#090c0eee';
/** Vertical rhythm between paragraphs inside a reply. */
export const ChatParagraphGap = '8px';
/** Reply bubble vertical padding, in theme spacing units (2px each). Shared
 *  with MessageList so fused rows can be collapsed to exactly the paragraph
 *  gap. */
export const ChatBubblePaddingY = 3;
/** A hair of air between bullets — still a tight group. */
export const ChatListItemGap = '2px';
